module.exports = __webpack_public_path__ + "img/mood_board_360_trigger_1.7ffad68f.jpg";